import { Grid, HStack, Heading, Stack } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { TrackedButton } from '$/components/common/Button/TrackedButton';
import { StyledScrollWrapper } from '$/components/common/StyledScrollWrapper';
import { useAuthorization } from '$/components/core/Authentication/hooks/useAuthorization';
import { useIsMobile } from '$/hooks/useIsMobile';
import { SchoolClassCard } from '$/pages/SchoolClassesPage/components/SchoolClassCard';
import { SchoolClassModal } from '$/pages/SchoolClassesPage/components/SchoolClassModal';
import { useSchoolClassModal } from '$/pages/SchoolClassesPage/hooks/useSchoolClassModal';
import { schoolClassesQuery } from '$/services/usecases/school/queries';
import { materialTemplateColumn } from '$/theme/utils/templateColumn';

export const SchoolClassesPage = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const { hasPermission } = useAuthorization();
  const onOpenModal = useSchoolClassModal.useOnOpen();
  const { data: schoolClassesData } = useQuery(schoolClassesQuery());

  return (
    <Stack
      w='full'
      {...(!isMobile && {
        layerStyle: 'DashboardSection',
      })}
    >
      <StyledScrollWrapper>
        <Stack
          gap='6'
          overflowY='auto'
          w='full'
          {...(!isMobile && {
            p: '7',
          })}
        >
          <HStack justify='space-between'>
            <Heading as='h1' fontSize='3xl'>
              {t('school.schoolClasses.title')}
            </Heading>
            {hasPermission('School_Create_Class') && (
              <TrackedButton
                h='10'
                fontSize='sm'
                onClick={() => onOpenModal('createClass')}
                contentName='School'
                contentPiece='SchoolClasses'
                contentTarget='AddClass'
              >
                {t('school.schoolClasses.createClassButton')}
              </TrackedButton>
            )}
          </HStack>
          <Grid gap='6' templateColumns={materialTemplateColumn()}>
            {schoolClassesData?.response.map((schoolClass) => (
              <SchoolClassCard key={schoolClass.id} schoolClass={schoolClass} />
            ))}
          </Grid>
        </Stack>
      </StyledScrollWrapper>
      <SchoolClassModal />
    </Stack>
  );
};
